module.exports = __webpack_public_path__ + "static/media/wireframe-device-browser-cellphone.81e62e45.png";